import {applyMiddleware, createStore} from 'redux';

import createReducer from '../shared/reducers';
import {createLogger} from 'redux-logger'; // https://github.com/evgenyrodionov/redux-logger
import thunkMiddleware from 'redux-thunk'; // https://github.com/gaearon/redux-thunk
import debug from 'debug';

const log = debug('circleblack:redux');
const logger = {log};

const myStore = createStore(createReducer(), applyMiddleware(thunkMiddleware, createLogger({logger})));

myStore.reducers = {};

export default myStore;
export * from '../shared/reducers/user';
export * from '../shared/reducers/modals';
export * from '../shared/reducers/product';
export * from '../shared/reducers/periods';
export * from '../shared/reducers/badges';
export * from '../shared/reducers/headerNotification';

export function injectReducer(name, reducer) {
  myStore.reducers[name] = reducer;
  myStore.replaceReducer(createReducer(myStore.reducers));
}
